const config = {
  start: 'hmUI.anim_status.START',
  pause: 'hmUI.anim_status.PAUSE',
  stop: 'hmUI.anim_status.STOP',
  resume: 'hmUI.anim_status.RESUME'
}

export default config
